import React, { useState, useEffect, Fragment } from "react";
import clsx from "clsx";
import { Route, Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import firebase from "./firebase";
import { setNeedEmailVerify, setZlaboPremium, changeIsPaid } from "./actions/actions.js";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

import InheritanceTax from "./pages/InheritanceTax";
import Decrease from "./pages/Decrease";
import Insurance from "./pages/Insurance";
import SeverancePay from "./pages/SeverancePay";
import SeverancePay2 from "./pages/SeverancePay2";
import Setting from "./pages/Setting";
import Iryubun from "./pages/Iryubun.js";
import Upgrade from "./pages/Upgrade";
import Account from "./pages/Account";
import TutrialList from "./components/TutrialList.jsx";


const drawerWidth = 240;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  drawerPaper: {
    position: "relative",
    width: drawerWidth,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  toolbarMargin: theme.mixins.toolbar,
  aboveDrawer: {
    zIndex: theme.zIndex.drawer + 1,
  },
  toolList: {
    height: "100%",
  },
  whetherUpdate: {
    display: "flex !important",
    flexDirection: "column",
    position: "absolute",
    color: "#ffffff",
    fontWeight: 800,
    bottom: 120,
  },
  alreadyUpdate: {
    color: "#fff",
    backgroundColor: "rgb(236, 105, 65)",
    width: "100%",
    textAlign: "center",
    padding: "0.5rem",
    fontWeight: 800
  },
  cautionForPremium: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  when: {
    display: "flex",
    flexDirection: "column",
    fontSize: "0.75rem",
    position: "absolute",
    bottom: 0,
  },
});

const MyToolbar = withStyles(styles)(({ classes, title, onMenuClick }) => (
  <Fragment>
    <AppBar className={classes.aboveDrawer}>
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
          onClick={onMenuClick}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" color="inherit" className={classes.flex}>
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
    <div className={classes.toolbarMargin} />
  </Fragment>
));

const MyDrawer = withStyles(styles)(
  ({ classes, variant, open, onOpen, onClose, onItemClick, zlaboPremium, needEmailVerify, isPaid }) => (
    <div>
      <SwipeableDrawer
        variant={variant}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div
          className={clsx({
            [classes.toolbarMargin]: variant === "persistent",
          })}
        />
        {/* {console.log("props.zlabopremium on tool.js: ", zlaboPremium, "props.needemailverify on tool.js: ", needEmailVerify)} */}
        <List className={classes.toolList}>
          <ListItem
            button
            component={Link}
            to="/非課税枠の効果"
            onClick={() => onItemClick()}
          >
            <ListItemText>非課税枠の効果</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/相続税計算・限界税率"
            onClick={() => onItemClick()}
          >
            <ListItemText>相続税計算・限界税率</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/相続税の減少効果"
            onClick={() => onItemClick()}
          >
            <ListItemText>相続税の減少効果</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/遺産分割シミュレーション"
            onClick={() => onItemClick()}
          >
            <ListItemText>遺産分割シミュレーション</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/退職金の手取計算"
            onClick={() => onItemClick()}
          >
            <ListItemText>退職金の手取計算</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            divider
            to="/退職金の支給可能目安"
            onClick={() => onItemClick()}
          >
            <ListItemText>退職金の支給可能目安</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/アップグレード"
            divider
            onClick={() => onItemClick()}
          >
            <ListItemText>アップグレード</ListItemText>
          </ListItem>
          <ListItem
            button
            onClick={() =>
              window.open("https://z-lab.jp/announce/list", "_blank")
            }
          >
            <ListItemText>ニュース</ListItemText>
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/設定"
            onClick={() => onItemClick()}
          >
            <ListItemText>設定</ListItemText>
          </ListItem>
          <ListItem style={{ display: "none" }} className={clsx(((isPaid && !zlaboPremium) || (zlaboPremium && !needEmailVerify)) && classes.whetherUpdate)}>
            <ListItemText className={clsx(((isPaid && !zlaboPremium) || (zlaboPremium && !needEmailVerify)) && classes.alreadyUpdate)}><span style={{ fontWeight: "bold", }}>アップグレード済み</span></ListItemText>
            <div className={clsx((zlaboPremium && !needEmailVerify) && classes.cautionForPremium)} style={{ fontSize: "0.75rem", fontWeight: 400 }}>
              ※ゼットラボプレミアム会員を退会されると本アプリの特典も停止されます。ご了承ください。
            </div>
          </ListItem>
          <ListItem className={classes.when}>
            <div>
              ※本サービスは、令和2年10月1日現在の制度をもとに試算しています。
            </div>
            <div>
              ※税務に関する個別のご相談やお問い合わせは、必ず所轄の税務署や顧問税理士等にご確認ください。
            </div>
          </ListItem>
        </List>
      </SwipeableDrawer>
      <main className={classes.content}>
        <Route exact path="/" component={Insurance} />
        <Route path="/非課税枠の効果" component={Insurance} />
        <Route path="/相続税計算・限界税率" component={InheritanceTax} />
        <Route path="/相続税の減少効果" component={Decrease} />
        <Route path="/遺産分割シミュレーション" component={Iryubun} />
        <Route path="/退職金の手取計算" component={SeverancePay} />
        <Route path="/退職金の支給可能目安" component={SeverancePay2} />
        <Route path="/アップグレード" component={Upgrade} />
        <Route path="/アカウント" component={Account} />
        <Route path="/設定" component={Setting} />
        <Route path="/チュートリアル" component={TutrialList} />
      </main>
    </div>
  )
);

function AppBarInteraction({ classes, variant }) {
  const [drawer, setDrawer] = useState(false);
  // const zlaboPremium = useSelector(state => state.user.isPaid);
  const needEmailVerify = useSelector(state => state.user.needEmailVerify);
  const isPaid = useSelector(state => state.user.isPaid);
  const [zlaboPremium, setZlaboPremium] = useState(false);

  const dispatch = useDispatch();
  let location = useLocation();
  let tmp = location.pathname;
  if (tmp === "/") {
    tmp = "/非課税枠の効果";
  }
  const title = tmp.slice(1);
  useEffect(() => {
    // console.log("tool drawer: ");
    var user = firebase.auth().currentUser;
    if (user) {
      const db = firebase.firestore();
        user.reload().then(() => {
          db.collection('customers')
            .doc(user.uid)
            .onSnapshot(async (snapshot) => {
              setZlaboPremium(!!snapshot.data().zlabo_premium);
              // console.log("zlabopremium on tool", zlaboPremium);
              if (zlaboPremium && user.emailVerified) {
                dispatch(setNeedEmailVerify(false));
              } else if (zlaboPremium && !user.emailVerified) {
                dispatch(setNeedEmailVerify(true));
              } else {
                dispatch(setNeedEmailVerify(false));
              }
            })
        });
    } else {
      setZlaboPremium(false);
      dispatch(setNeedEmailVerify(false));
      dispatch(changeIsPaid(false));
    }
  }, [drawer]);

  // useEffect(()=>{
  //   var user = firebase.auth().currentUser;
  //   if (user) {
  //     const db = firebase.firestore();
  //       db.collection('customers')
  //         .doc(user.uid)
  //         .onSnapshot(async (snapshot) => {
  //           console.log("snapshot tool.js: ", snapshot.data().zlaboPremium);
  //           dispatch(setZlaboPremium(!!snapshot.data().zlabo_premium));
  //         });
  //   }
  // }, [zlaboPremium, dispatch])

  const onItemClick = () => {
    setDrawer(variant === "temporary" ? false : drawer);
    setDrawer(!drawer);
  };

  const toggleDrawer = () => {
    setDrawer(!drawer);
  };

  return (
    <div className={classes.root}>
      <MyToolbar title={title} onMenuClick={toggleDrawer} />
      <MyDrawer
        open={drawer}
        onOpen={toggleDrawer}
        onClose={toggleDrawer}
        variant={variant}
        onItemClick={onItemClick}
        needEmailVerify={needEmailVerify}
        zlaboPremium={zlaboPremium}
        isPaid={isPaid}
      />
    </div>
  );
}

export default withStyles(styles)(AppBarInteraction);
